export default "__VITE_ASSET__f40b91fc__"